<template>
    <div class="modal-card" id="draggable" >
        <header class="modal-card-head pop-header">
            <p class="modal-card-title tit">
                차량 등록
                <button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button>
            </p>
        </header>
        <section class="modal-card-body pop-content">
            <div class="inner-box">
                <table class="visit-info-table">
                    <colgroup>
                        <col width="35%"></col>
                        <col width="*"></col>
                    </colgroup>
                    <tr>
                        <td class="tit">차량출입목적</td>
                        <td>
                            <select v-model="purpose">
                                <option
                                        v-for="code in purposeCds"
                                        :key="code.key"
                                        :value="code.key"
                                        v-text="code.value"/>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td class="tit">차량구분</td>
                        <td>
                            <select v-model="carCategory">
                                <option
                                        v-for="car in carCategoryCds"
                                        :key="car.key"
                                        :value="car.key"
                                        v-text="car.value"/>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td class="tit">차량명</td>
                        <td><input class="input" type="text" ref="carNm" v-model="carNm" style="width:100%"></td>
                    </tr>
                    <tr>
                        <td class="tit">차량번호</td>
                        <td><input class="input" type="text" ref="carNumber" v-model="carNumber" style="width:100%"></td>
                    </tr>
                    <tr>
                        <td class="tit">운전자</td>
                        <td>
                            <div class="write">
                                {{childVisitNm}}
                            </div>
                        </td>
                    </tr>
                </table>



                <br><br>
                <button class="button-request" @click="save">
                    등록
                </button>
                <button class="button-close" @click="$parent.close()">
                    닫기
                </button>

            </div>
        </section>
    </div>
</template>

<script>
    import Vue from "vue";
    import _ from "lodash";

    export default {
        name: "carItem",
        props: {
            childVisitNm: {
                type: String,
                required: true
            },
            visitorSeq: {
                type: Number,
                required: true
            },
            childPersonCars: {
                type: Array,
                required: false
            },
            compCd: {
                type: String,
                required: true
            },
        },

        data() {
            return {
                title: "차량등록",
                purposeCds: [],
                carCategoryCds: [],
                purpose: "",
                carCategory: "",
                carNm: "",
                carNumber: "",
            }
        },
        methods: {
            save() {
                if(this.carNm==""){
                    setTimeout(()=> {
                        this.$swal({type: 'warning', text: '차량명을 입력해주세요.'}).then(() => {
                        })
                            ,10})
                    this.$refs.carNm.focus();
                    return false;
                }

                if(this.carNumber==""){
                    setTimeout(()=> {
                        this.$swal({type: 'warning', text: '차량번호를 입력해주세요.'}).then(() => {
                        })
                            ,10})
                    this.$refs.carNumber.focus();
                    return false;
                }

                let visitItemData = {
                    visitorSeq : this.visitorSeq,
                    purpose : this.purpose,
                    carCategory : this.carCategory,
                    carNm : this.carNm,
                    carNumber : this.carNumber,
                }

                this.$swal({type: 'info', text: this.childVisitNm + ' 사용자의 차량정보가 등록되었습니다.'});
                this.$emit('close', visitItemData)
                this.closeModal();
            },

            closeModal() {
                this.$parent.close();
            },

            getPurposeCdCombo() {
                this.$http.get(`/api/code/combo`, { params: { compCd: this.compCd,  groupCd: "PURPOSE_CD" } })
                    .then(response => {
                        this.purposeCds = response.data;
                        this.purpose = this.purposeCds[0].key;
                    }).finally(()=>{
                    for(var i=0; i <this.childPersonCars.length; i++) {
                        if(this.visitorSeq == this.childPersonCars[i].visitorSeq){
                            this.purpose = this.childPersonCars[i].purpose
                        }
                    }
                });
            },
            getCarCateCdCombo() {
                this.$http.get(`/api/code/combo`, { params: { compCd: this.compCd,  groupCd: "VISITOR_CAR_CATEGORY" } })
                    .then(response => {
                        this.carCategoryCds = response.data;
                        this.carCategory = this.carCategoryCds[0].key;
                    }).finally(()=>{
                    for(var i=0; i <this.childPersonCars.length; i++) {
                        if(this.visitorSeq == this.childPersonCars[i].visitorSeq){
                            this.carCategory = this.childPersonCars[i].carCategory
                        }
                    }
                });
            },
            getVisitCarInfoSet() {
                for(var i=0; i <this.childPersonCars.length; i++) {
                    if(this.visitorSeq == this.childPersonCars[i].visitorSeq){
                        this.carNm = this.childPersonCars[i].carNm
                        this.carNumber = this.childPersonCars[i].carNumber
                    }
                }
            },
        },

        mounted() {
            this.getPurposeCdCombo();
            this.getCarCateCdCombo();
            this.getVisitCarInfoSet();
        },
    }
</script>

<style>
    .inner-box{
        height: 100%;
        width:100%;
        left: 0;
        right: 0;
        margin: 0 auto 30px;
    }

    .inner-box button{
        padding:10px;
        border:1px solid #d5d5d5;
        text-align:center;
        font-weight: bold;
    }

    .inner-box .button-request{
        background-color: #023e7c;
        color:#fff;
        width:100px;
    }

    .inner-box .button-close{
        background-color: #b3b3b3;
        color:#fff;
        width:100px;
        margin-left:10px;
    }

    @media (min-width: 1000px) {
        .modal-card {
            width:850px;
        }
    }
</style>